// How an employment type string maps to a payroll worker payment type.
// Mirrors server/src/helpers/payroll/workerPaymentType.js - keep the logic
// byte-identical so the client never disagrees with pay-run grouping.

export const getWorkerPaymentType = (employmentType = '') => {
  const normalised = employmentType.toLowerCase()
  if (
    normalised.includes('self') ||
    normalised.includes('invoice') ||
    normalised.includes('contractor') ||
    normalised.includes('ltd')
  ) {
    return 'Invoice'
  }
  if (normalised.includes('paye') || normalised.includes('employee')) {
    return 'PAYE'
  }
  return 'Unknown'
}

export default getWorkerPaymentType
